// extracted by mini-css-extract-plugin
export default {"container":"NewMerchantsPreOrder_container__iHOtv","title":"NewMerchantsPreOrder_title__x9dBL","submit":"NewMerchantsPreOrder_submit__uJ0zM"};